module.exports = __webpack_public_path__ + "media/images/regional-image8-24ff43c5c40bd4879be0e3df34494a95.jpg";